import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const DTMFIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path d="M5 6C5 5.44772 5.44772 5 6 5H8C8.55228 5 9 5.44772 9 6V8C9 8.55228 8.55228 9 8 9H6C5.44772 9 5 8.55228 5 8V6Z" />
      <path d="M5 24C5 23.4477 5.44772 23 6 23H8C8.55228 23 9 23.4477 9 24V26C9 26.5523 8.55228 27 8 27H6C5.44772 27 5 26.5523 5 26V24Z" />
      <path d="M6 14C5.44772 14 5 14.4477 5 15V17C5 17.5523 5.44772 18 6 18H8C8.55228 18 9 17.5523 9 17V15C9 14.4477 8.55228 14 8 14H6Z" />
      <path d="M14 6C14 5.44772 14.4477 5 15 5H17C17.5523 5 18 5.44772 18 6V8C18 8.55228 17.5523 9 17 9H15C14.4477 9 14 8.55228 14 8V6Z" />
      <path d="M15 23C14.4477 23 14 23.4477 14 24V26C14 26.5523 14.4477 27 15 27H17C17.5523 27 18 26.5523 18 26V24C18 23.4477 17.5523 23 17 23H15Z" />
      <path d="M14 15C14 14.4477 14.4477 14 15 14H17C17.5523 14 18 14.4477 18 15V17C18 17.5523 17.5523 18 17 18H15C14.4477 18 14 17.5523 14 17V15Z" />
      <path d="M24 5C23.4477 5 23 5.44772 23 6V8C23 8.55228 23.4477 9 24 9H26C26.5523 9 27 8.55228 27 8V6C27 5.44772 26.5523 5 26 5H24Z" />
      <path d="M23 24C23 23.4477 23.4477 23 24 23H26C26.5523 23 27 23.4477 27 24V26C27 26.5523 26.5523 27 26 27H24C23.4477 27 23 26.5523 23 26V24Z" />
      <path d="M24 14C23.4477 14 23 14.4477 23 15V17C23 17.5523 23.4477 18 24 18H26C26.5523 18 27 17.5523 27 17V15C27 14.4477 26.5523 14 26 14H24Z" />
    </BaseIcon>
  );
};
